import { v4 as uuidv4 } from 'uuid';

import { IUUserContext } from '../contexts/UserContext';
import { createUnauthHeader } from '../lib/performance';
import logRpc from '../util/logRpc';

import { augmentService } from 'Common/src/lib/ThriftServiceAugmentor';
import Net from 'Common/src/lib/Net';

import {
  TAppElkImageStyle,
  TElkGenerateImageRequest,
  TElkGenerateImageResponse,
  TElkGenerateSampleImageRequest,
  TElkGetThemeSuggestionRequest,
  TElkGetThemeSuggestionResponse
} from 'TProtocol/prototypes/events/messages';
import { TElkThemeService } from 'PProtocol/prototypes/events';
import { IUEvent } from '../lib/event';

const createService = (): TElkThemeService.Client => {
  return augmentService(Net.createService(TElkThemeService, '/json/ElkThemeService'));
};

export const getEventThemeSuggestion = async (userContext: IUUserContext,
  eventName: string): Promise<TElkGetThemeSuggestionResponse> => {
  logRpc(userContext, 'getEventThemeSuggestion');
  const request: TElkGetThemeSuggestionRequest = new TElkGetThemeSuggestionRequest({
    eventName
  });

  const client: TElkThemeService.Client = createService();

  return client.getEventThemeSuggestion(createUnauthHeader(), request);
};

export const generateEventImage = async (userContext: IUUserContext, event: IUEvent, useVerbatim: boolean,
  prompt: string | undefined, style?: TAppElkImageStyle): Promise<TElkGenerateImageResponse> => {
  logRpc(userContext, 'generateEventImage');
  const request: TElkGenerateImageRequest = new TElkGenerateImageRequest({
    eventName: event.title,
    eventUuid: event.id,
    prompt,
    useVerbatim: useVerbatim,
    taskId: uuidv4(),
    style
  });

  const client: TElkThemeService.Client = createService();

  return client.generateEventImage(userContext.getAuthHeader(), request);
};

export const sampleEventImage = async (
  userContext: IUUserContext,
  event: IUEvent,
  remainingCoinBalance: number,
  useVerbatim: boolean,
  prompt: string | undefined,
  style?: TAppElkImageStyle
): Promise<TElkGenerateImageResponse> => {
  logRpc(userContext, 'generateEventImage');
  const request: TElkGenerateSampleImageRequest = new TElkGenerateSampleImageRequest({
    eventName: event.title,
    eventUuid: event.id,
    prompt,
    useVerbatim: useVerbatim,
    taskId: uuidv4(),
    remainingCoinBalance,
    style
  });

  const client: TElkThemeService.Client = createService();

  return client.sampleEventImage(createUnauthHeader(), request);
};
